import React from "react";
import {
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel, OverlayTrigger
} from "react-bootstrap";
// react component that creates a dropdown menu for selection
import "react-select/dist/react-select.css";
// react component that creates a dropdown menu for selecting a date
import Datetime from "react-datetime";
import Card from "../../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';

import Checkbox from '../../../components/CustomCheckbox/CustomCheckbox.jsx';
import ReactDOM from 'react-dom';
import Switch from "react-bootstrap-switch";

class Clauses_Step2 extends React.Component {
  constructor(props) {
    super(props);
    this._grabUserInput = this._grabUserInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.state = {
      IncludedClauses: props.getStore().IncludedClauses,
      consentClauses: props.getStore().consentClauses,
      consentClausesStatus: props.getStore().consentClausesStatus,
      serviceError: null,
      mydateError: null
    };
  }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    failedAlert(){
        this.setState({
            alert: (
                <SweetAlert
                    danger
                    style={{display: "block"}}
                    title="Please acknowledge ALL required Clauses!"
                    onConfirm={() => this.setState({alert: null})}
                    onCancel={() => this.setState({alert: null})}
                    confirmBtnBsStyle="danger"
                >
                </SweetAlert>
            )
        });
    }

    handleSwitch(elem, state) {
        debugger;
        var thenum = elem.props.id.replace( /^\D+/g, '');
        this.props.consentSubmission.consentClausesStatus[thenum].checked = state;

        //this.setState({Enabled: state});
        /*
        console.log('handleSwitch. elem:', elem);
        console.log('name:', elem.props.name);
        console.log('new state:', state);*/
    }

    isValidated() {
      //debugger;
      const userInput = this._grabUserInput(); // grab user entered vals

      //Lets run throught the Clauses Array and see if its a required clause, is so then cross reference the element in
      //the Status array using the index and store the results, returning valid if they acknowledged all the required
      //clauses

      var valid = true;
      this.props.consentSubmission.IncludedClauses.map((e, key) => {
          if (e.Required === "Required") {
              if (this.props.consentSubmission.consentClausesStatus[key].checked === false) {
                  valid = false;
              }
          }
      });
          if(valid)
              this.props.updateStore({
                  ...userInput,
                  savedConsent: false // use this to notify step4 that some changes took place and prompt the user to save again
              });
          else
              this.failedAlert();

          return valid;
  }
    _grabUserInput() {
      //debugger;
        var number;
        this.props.consentSubmission.IncludedClauses.map((e, key) => {
            if ((e.Type === "Checkbox") || (e.Type === "Yes/No")) {
                number = "checkbox" + key;
                //Store all the states for validation and for when we move forward or back on wizard
                //We will use this same loop structure in the validation routine to check that the required clauses are
                //checked.
                this.props.consentSubmission.consentClausesStatus[key].checked = document.getElementById(number).checked;
            }
        });
        return {
            consentClausesStatus: this.props.consentSubmission.consentClausesStatus
        };
    }
    handleChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({ service: ReactDOM.findDOMNode(this.select).value });
    };
  render() {
      var tasks = [];
      var number;
      var label;
      if (this.props.consentSubmission.consentClauses === undefined || this.props.consentSubmission.consentClauses.length === 0)
          {
              this.props.consentSubmission.IncludedClauses.map((e, key) => {
                  if (e.Type === "Checkbox") {
                      number = "checkbox" + key;
                      this.props.consentSubmission.consentClausesStatus.push({checked: false});
                      this.props.consentSubmission.consentClauses.push(
                          <tr key={key}>
                              <td>
                                  <Checkbox
                                      number={number}
                                      isChecked={false}
                                      label={e.Required === "Required" ? <span className="text-danger">*</span> : ""}
                                  />
                              </td>
                              <td>{e.Text}</td>
                          </tr>
                      );
                  }
                  else if (e.Type === "Yes/No") {
                      number = "checkbox" + key;
                      this.props.consentSubmission.consentClausesStatus.push({checked: false});
                      this.props.consentSubmission.consentClauses.push(
                          <tr key={key}>
                              <td>
                                  <label htmlFor="male">Yes</label>
                                  <Checkbox
                                      number={number}
                                      isChecked={false}
                                      label={e.Required === "Required" ? <span className="text-danger">*</span> : " Yes"}
                                  />
                              </td>
                              <td>{e.Text}</td>
                          </tr>
                      );
                  }
              })
          }
      else
      {
          //empty the clauses and rebuild them setting the last state
          this.props.consentSubmission.consentClauses = [];
          this.props.consentSubmission.IncludedClauses.map((e, key) => {
              if (e.Type === "Checkbox") {
                  number = "checkbox" + key;
                  this.props.consentSubmission.consentClauses.push(
                      <tr key={key}>
                          <td>
                              <Checkbox
                                  number={number}
                                  isChecked={this.props.consentSubmission.consentClausesStatus[key].checked}
                                  label={e.Required === "Required" ? <span className="text-danger">*</span> : ""}
                              />
                          </td>
                          <td>{e.Text}</td>
                      </tr>
                  );
              }
              else if (e.Type === "Yes/No") {
                  number = "checkbox" + key;
                  this.props.consentSubmission.consentClauses.push(
                      <tr key={key}>
                          <td>
                              <label htmlFor="male">Yes</label>
                              <Checkbox
                                  number={number}
                                  isChecked={this.props.consentSubmission.consentClausesStatus[key].checked}
                                  label={e.Required === "Required" ? <span className="text-danger">*</span> : "Yes"}
                              />
                          </td>
                          <td>{e.Text}</td>
                      </tr>
                  );
              }

          })
      }
    return (
      <div className="wizard-step">
          <Row>
              <Col md={12}>
                  <Card
                      title="Consent Clauses"
                      category="Please read and acknowledge the following consent clauses:"
                      content={
                          <table className="table">
                              <tbody>{this.props.consentSubmission.consentClauses}</tbody>


                          </table>


                      }
                  />
                  <FormGroup>
                      <ControlLabel><div>
                          <h5>
                              If any consent clause, section, subsection, provision or phrase of this release
                              is found to be unenforceable or invalid, that portion shall be severed from this contract.
                              The remainder of this contract will then be construed as though the unenforceable portion
                              had never been contained in this document.
                          </h5>
                      </div>
                      </ControlLabel>
                  </FormGroup>
                  {this.state.alert}
              </Col>
          </Row>
      </div>
    );
  }
}

export default Clauses_Step2;



// WEBPACK FOOTER //
// ./src/views/Forms/DisplayConsentFormWizard/Clauses_Step2.jsx